/*******************************************************************************
 * types
 ******************************************************************************/
import { ErrorPayload, IoState } from "#store/types";
import { IQueryTableResult } from "#services/pilotService/responses/types";
import { Action } from "@iva/store-utils";
import { IBackendResult } from "@inode/types2";

export enum QueryType {
    SQL = "SQL",
    SPARQL = "SPARQL",
}

export type DataRow = IBackendResult[];

export interface FeedbackData {
    tableIndex: number;
    feedback: string;
}

export type TableResultMap = {
    [key: number]: IoState<IQueryTableResult>;
};
// State definition
export interface TablesState {
    readonly query: string;
    readonly pending: boolean[];
    readonly requestId: string;
    readonly tableResults: TableResultMap;
}

// Action types definition
export enum TableActionIdentifiers {
    FETCH_TABLE_STARTED = "@@tables/FETCH_STARTED",
    FETCH_TABLE_FAILED = "@@tables/FETCH_FAILED",
    FETCH_TABLE_SUCCEEDED = "@@tables/FETCH_SUCCEEDED",
}

// Actions definition
export type TableFetchStartedActionType = Action<
    TableActionIdentifiers.FETCH_TABLE_STARTED,
    number
>;
export type TableFetchSucceededActionType = Action<
    TableActionIdentifiers.FETCH_TABLE_SUCCEEDED,
    IQueryTableResult
>;
export type TableFetchFailedActionType = Action<
    TableActionIdentifiers.FETCH_TABLE_FAILED,
    ErrorPayload
>;
export type TableActionTypes =
    | TableFetchStartedActionType
    | TableFetchSucceededActionType
    | TableFetchFailedActionType;
